// extracted by mini-css-extract-plugin
export var MenuLinkWithDescription = "NestedMenu-module--MenuLinkWithDescription--3mkAW";